<template>
  <div
    v-if="recruiter"
    :class="[{'card-base card-shadow p-6':!noCard}, {'lg:h-fit lg:p-10 lg:pb-12': large}]"
  >
    <div
      :class="singleColumn ? 'flex-col ': 'items-center'"
      class="flex gap-4"
    >
      <RecruiterImage :image="recruiter.active_image?.url || ''" />
      <div :class="{'order-first': singleColumn}">
        <h2 class="my-2 font-semibold lg:text-lg">
          {{ recruiter.title }}
        </h2>
        <h3>{{ recruiter.role ?? 'Rol onbekend' }}</h3>
      </div>
    </div>
    <div
      v-if="large"
      class="mt-5 hidden lg:block"
    >
      <div class="text-lg font-semibold">
        {{ greeting }}!
      </div>
      <div>Hoe kan ik je helpen?</div>
    </div>
    <div class="my-6 space-y-3">
      <a
        class="block text-dynamic underline"
        :href="`mailto:${recruiter.email}`"
      >
        {{ recruiter.email }}
      </a>
      <a
        class="block text-dynamic underline"
        :href="`tel:${recruiter.phone}`"
      >
        {{ recruiter.phone }}
      </a>
    </div>
    <a
      v-if="recruiter?.whatsapp"
      :href="whatsappUrl"
      target="_blank"
      rel="nofollow noopener"
      class="btn btn-sm btn-secondary lg:btn-md"
    >
      Bericht via Whatsapp
    </a>
  </div>
</template>

<script setup lang="ts">
import type {Recruiter} from '~/graphql/graphql';

const props = defineProps<{
  recruiter: Recruiter
  detailed?: boolean
  large?: boolean
  singleColumn?: boolean
  noCard?: boolean
}>();

const date = new Date();
const hours = date.getHours();
const greeting = computed(() => (hours < 12) ? 'Goedemorgen' : ((hours <= 18 && hours >= 12) ? 'Goedemiddag' : 'Goedenavond'));


const whatsappUrl = computed(() => {
  let number = props?.recruiter?.whatsapp?.replace(/\D/g, '') || undefined;

  if (number?.[0] === '0') {
    number = `+31${number}`;
  }
  return `https://wa.me/${number}`;
});
</script>
